<template>
  <div v-if="initialTimecardsData && initialPayrollData">
    <TabSwitcher id="ts" :tabs="tabs" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import { Filter } from "@/components/DatatableV3.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import PayrollReport from "./PayrollReport.vue";
import TimeCardsReport from "./TimeCardsReport.vue";

const initialTimecardsData = ref<{
  source: string;
  filters: Filter[];
} | null>(null);

const initialPayrollData = ref<{
  source: string;
  filters: Filter[];
} | null>(null);

const tabs = computed(() => [
  {
    name: "Time Cards",
    component: TimeCardsReport,
    props: initialTimecardsData.value
  },
  {
    name: "Payroll",
    component: PayrollReport,
    props: initialPayrollData.value
  }
]);

onMounted(async () => {
  // Load initial page data and send to component as props
  const timecards = await fetch(
    `/company/timesheets/time_cards/initial_page_data`,
    {
      method: "GET"
    }
  );
  initialTimecardsData.value = await timecards.json();

  const payroll = await fetch(`/reports/payroll/initial_page_data`, {
    method: "GET"
  });
  initialPayrollData.value = await payroll.json();
});
</script>

<style scoped></style>
